import { render, staticRenderFns } from "./SubmissionsProgress.vue?vue&type=template&id=34b0ef25&scoped=true&"
import script from "./SubmissionsProgress.vue?vue&type=script&lang=js&"
export * from "./SubmissionsProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b0ef25",
  null
  
)

export default component.exports